import { Close } from '@mui/icons-material';
import { AlertColor, AlertTitle, Box, Alert as MuiAlert, SxProps, Theme, IconButton } from '@mui/material';

interface AlertProps {
  severity: AlertColor;
  overrideIcon?: React.ReactNode;
  title: string;
  message: string;
  sx?: {
    alert?: SxProps<Theme>;
    alertTitle?: SxProps<Theme>;
  };
  onClose?: () => void;
}

export const Alert = ({ severity, overrideIcon = undefined, title, message, sx = {}, onClose }: AlertProps) => (
  <MuiAlert
    severity={severity}
    {...(overrideIcon && { icon: overrideIcon })}
    sx={sx?.alert}
    action={
      onClose ? (
        <IconButton
          aria-label="close"
          color="inherit"
          size="small"
          onClick={onClose}
          sx={{
            right: 8,
            top: 0,
          }}
        >
          <Close fontSize="inherit" />
        </IconButton>
      ) : undefined
    }
  >
    <AlertTitle sx={sx?.alertTitle}>{title}</AlertTitle>
    <Box sx={{ whiteSpace: 'pre-line' }}>{message}</Box>
  </MuiAlert>
);
